/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * Způsob interpretace hodnoty atributu nad rámec základního typu. Prázdná hodnota (null) znamená prostý text.
 * @export
 * @enum {string}
 */

export const EnumInterpretace = {
    FORMATOVANYTEXT: 'FORMATOVANYTEXT',
    ODKAZ: 'ODKAZ',
    EMAIL: 'EMAIL',
    TELEFON: 'TELEFON',
    CISELNIK: 'CISELNIK',
    MULTI_CISELNIK: 'MULTI_CISELNIK'
} as const;

export type EnumInterpretace = typeof EnumInterpretace[keyof typeof EnumInterpretace];



